import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

//import { User } from '../../models/user';
/*
  Generated class for the GithubUsersProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WebServices {
  apiUrl = 'https://botapi.aaroananda.com/rest';
  botApiUrl="https://botapi.aaroananda.com/rest";
  apiBasePath="https://apis.aaroananda.com";
  
  constructor(public http: Http) { 
	let url=document.URL;
	let urlPart=url.split(":")[0];
	if(urlPart=="http"){
		this.apiUrl = 'https://botapi.aaroananda.com/rest';
		this.botApiUrl="https://botapi.aaroananda.com/rest";
	}

  }
  
  logActivity(email: string, activity: string, intent:string) {
		let time=Math.floor(Date.now()/1000);
		const headerDict = {
			'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
		};
		const requestOptions = {                                                                                                                                                                                 
		  headers: new Headers(headerDict),
		};
  		return this.http.post(this.botApiUrl+"/saveactivitylog?chatbotid=1&user="+encodeURIComponent(email)+"&activity="+encodeURIComponent(activity)+"&intent="+encodeURIComponent(intent)+"&userstimestamp="+encodeURIComponent(time.toString()),{},requestOptions)
		  .map(res =>res.json());
  }
  
  getMessage() {
    const headerDict = {
		'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
	};
	const requestOptions = {                                                                                                                                                                                 
	  headers: new Headers(headerDict),
	};
	var formData = new FormData();
    return this.http.get(this.botApiUrl+"/getmessage?chatbotid=1",requestOptions)
      .map(res =>res.json());
  }
  
  saveRating(email: string, rating: any, username:string) {
		const headerDict = {
			'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
		};
		const requestOptions = {                                                                                                                                                                                 
		  headers: new Headers(headerDict),
		};
  		return this.http.post(this.botApiUrl+"/saverating?chatbotid=1&userid="+encodeURIComponent(email)+"&username="+encodeURIComponent(username)+"&rating="+encodeURIComponent(rating),{},requestOptions)
		  .map(res =>res.json());
  }
  
  saveComment(id:any,email: string, rating: any, username:string,comment:string) {
		const headerDict = {
			'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
		};
		const requestOptions = {                                                                                                                                                                                 
		  headers: new Headers(headerDict),
		};
  		return this.http.post(this.botApiUrl+"/saveusercomment?chatbotid=1&id="+encodeURIComponent(id)+"&userid="+encodeURIComponent(email)+"&username="+encodeURIComponent(username)+"&rating="+encodeURIComponent(rating)+"&comment="+encodeURIComponent(comment),{},requestOptions)
		  .map(res =>res.json());
  }
  
  sendEmail(to: string, cc: string, subject:string,mailbody:string) {
		const headerDict = {
			'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
		};
		const requestOptions = {                                                                                                                                                                                 
		  headers: new Headers(headerDict),
		};
  		return this.http.post(this.apiUrl+"/sendemail?chatbotid=1&to="+encodeURIComponent(to)+"&cc="+encodeURIComponent(cc)+"&subject="+encodeURIComponent(subject)+"&mailbody="+encodeURIComponent(mailbody),{},requestOptions)
		  .map(res =>res.json());
  }
  
  getIntentByParent(parent:any,userid: string) {
		const headerDict = {
			'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
		};
		const requestOptions = {                                                                                                                                                                                 
		  headers: new Headers(headerDict),
		};
  		return this.http.post(this.botApiUrl+"/getIntentByParent?chatbotid=1&parent="+encodeURIComponent(parent)+"&userid="+encodeURIComponent(userid),{},requestOptions)
		  .map(res =>res.json());
  }
  
  getIntentById(id:any,userid: string) {
		const headerDict = {
			'Authorization':'Basic YmlzaHdhaml0LmtvbGF5QGFicC5pbjoxMjM0NTY='
		};
		const requestOptions = {                                                                                                                                                                                 
		  headers: new Headers(headerDict),
		};
  		return this.http.get(this.botApiUrl+"/getIntentById?chatbotid=1&id="+encodeURIComponent(id)+"&userid="+encodeURIComponent(userid),requestOptions)
		  .map(res =>res.json());
  }
  
  getEmployeeByEmail(email: string) {
  		return this.http.get(this.botApiUrl+"/getEmployeeByEmail?email="+encodeURIComponent(email))
		  .map(res =>res.json());
  }
  
  getUserProfile(hashKey){
	const headerDict = {
		'Authorization':'Basic '+hashKey
	};
	const requestOptions = {                                                                                                                                                                                 
	  headers: new Headers(headerDict),
	};
	var formData = new FormData();
	return this.http.post(this.apiBasePath+"/userProfile",formData,requestOptions)
	  .map(res =>res.json());
  }
  
  createSupportTicket(hashKey :any, topic:any,message: string){
	const headerDict = {
		'Authorization':'Basic '+hashKey
	};
	const requestOptions = {                                                                                                                                                                                 
	  headers: new Headers(headerDict),
	};
	/*var formData = new FormData();
	return this.http.post(this.apiBasePath+"/userProfile",formData,requestOptions)
	  .map(res =>res.json());
	*/  
	 return this.http.get(this.apiBasePath+"/createSupportTicket?topic="+encodeURIComponent(topic)+"&response="+encodeURIComponent(message),requestOptions)
		  .map(res =>res.json());
  }

}


// WEBPACK FOOTER //
// ./src/providers/web-services/web-services.ts